import Phaser from 'phaser';

/**
 * Tiny "HAYTERWAVE MEDIA LLC" credit. Drawn at the very bottom-right of
 * whichever scene calls it. Kept extremely understated so it never competes
 * with gameplay or UI — single line, mono, faint.
 */
export function drawWatermark(scene: Phaser.Scene): Phaser.GameObjects.GameObject[] {
  const { width, height } = scene.scale;
  const x = width - 15;
  const y = height - 15;

  // Depth ~950 — above HUD (depth 900–920) but below any modal popup
  // (depth 1650+) so tutorial cards never get clipped by the watermark.
  const tag = scene.add.text(x, y, 'HAYTERWAVE MEDIA LLC', {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: '20px',
    color: '#3a4674',
    fontStyle: 'bold',
  }).setOrigin(1, 1).setScrollFactor(0).setDepth(950);

  const tw = tag.width;
  const hair = scene.add.rectangle(x, y - tag.height - 3, tw, 1, 0x3a4674, 0.85)
    .setOrigin(1, 0.5).setScrollFactor(0).setDepth(950);

  return [tag, hair];
}
